<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <p class="bottom-20 bold-font">Tell us about the applicant</p>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{ error }}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p class="bottom-20 bold-font">Agent being used for this enrollment: {{enrollmentViewModel.AGENTNAME}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>

    <div class="row" *ngIf="!isSingleGroup">
        <div class="col-24">
            <ElectionPeriod [reasonCode]="reasonCode.toString()"
                            [periodSelected]="periodSelected"
                            (periodSelectdChanged)="periodSelectdChanged($event)"
                            (reasonCodeChanged)="reasonCodeChanged($event)"
                            (hasDateField)="hasDateField($event)"
                            (sepDateChange)="sepdatechange($event)">
            </ElectionPeriod>
        </div>
    </div>

    <div *ngIf="isSingleGroup">

        <!--start disenrollment section-->

        <div class="row">
            <div class="col-16">
                <fieldset class="radio">
                    <strong>I want to Disenroll or Cancel a member</strong>
                    <ValidatedRadioButtonGroup [options]="rdDisCancel"
                                               [selectedValue]="enrollmentViewModel.DISENROLLIND"
                                               [radioGroupName]="'rdBtnDisCancel'"
                                               (onValueChange)="ShowDisCancelEnrll($event)">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div *ngIf="IsDisEnrllYES">
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label>Disenrollment/Cancellation Date of Notice</label>
                        <JQDatePicker [selectedDate]="enrollmentViewModel.DISENROLLNOTICEDT"
                                      (elementClicked)="enrollmentViewModel.DISENROLLNOTICEDT = $event">
                        </JQDatePicker>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label>Disenrollment/Cancellation Effective Date</label>
                        <JQDatePicker [selectedDate]="enrollmentViewModel.DISENROLLDATE"
                                      (elementClicked)="enrollmentViewModel.DISENROLLDATE = $event">
                        </JQDatePicker>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [selectedValue]="enrollmentViewModel.DISENROLLREASONCD"
                                           [label]="'Disenrollment/Cancellation Reason Code'"
                                           (onValueChange)="DisEnrllReasonCode($event)"
                                           [options]="disEnrllReasonCode"
                                           [disabled]="disabled">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">

                        <legend class="black-text">Disenrollment/Cancellation Type</legend>
                        <input type="text" value="{{disenrllType}}" disabled="disabled" />
                        <!--<ValidatedTextField [label]="'Disenrollment/Cancellation Type'">
                        </ValidatedTextField>-->
                        <!--<ValidatedDropDown class="wide"
                        [selectedValue]="enrollmentViewModel.DISENROLLTYPE"
                        [label]="'Disenrollment/Cancellation Type'"
                        (onValueChange)="enrollmentViewModel.DISENROLLTYPE = $event"
                        [options]="disEnrllType"
                        [disabled]="disabled">
                          </ValidatedDropDown>-->

                    </div>
                </div>
            </div>
        </div>

        <!--end of disenrll-->

        <div class="row">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="black-text">Election Period</legend>
                    <ValidatedRadioButtonGroup [options]="electionPeriodsList"
                                               [selectedValue]="enrollmentViewModel.ELECTION"
                                               [radioGroupName]="'electionPeriod'">
                    </ValidatedRadioButtonGroup>
                </fieldset>

            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div>
                    <label>Election Option</label>
                    <p>I am leaving/losing/joining employer or union coverage. My coverage changed or will change on</p>
                    <JQDatePicker [selectedDate]="enrollmentViewModel.SEPEFFDT"
                                  (elementClicked)="enrollmentViewModel.SEPEFFDT = $event">
                    </JQDatePicker>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <br />
    </div>

    <div class="row">
        <div class="col-24">
            <drugplan [enrollmentDrugViewModel]="enrollmentViewModel"></drugplan>
        </div>
    </div>
    <br />
    <br />

    <!--<div class="row" *ngIf="showSTCOBFields">
        <div class="col-24">
            <label>Group Name</label>
            <jqxDropDownButton #myDropDownButton [width]="150" [height]="50">
                <jqxGrid #myGrid (onRowselect)="myGridOnRowSelect($event)"
                         [width]="750" [source]="dataAdapter" [columns]="columns" [ready]="ready"
                         [pageable]="true" [columnsresize]="true" [autoheight]="true">
                </jqxGrid>
            </jqxDropDownButton>
            <div class="row" *ngIf="showGroupDetails">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="Carrier"
                                            [text]="this.enrollmentViewModel.CARRIER"
                                            [disabled]="true">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="Account"
                                            [text]="this.enrollmentViewModel.ACCOUNT"
                                            [disabled]="true">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="Group"
                                            [text]="this.enrollmentViewModel.GROUP"
                                            [disabled]="true">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>

        </div>
    </div>-->


    <div class="row">
        <div class="col-24">
            <beneficiary-info [enrollment]="enrollmentViewModel.beneficiaryInfo"
                              (onValueChange)="this.change($event)"></beneficiary-info>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <DualAddress [topAddress]="residentialAddress"
                         [bottomAddress]="mailingAddress"
                         [topAddressName]="'Permanent Address/Long Term Care Address'"
                         [bottomAddressName]="'Mailing Address'"
                         [LTCFacilityName]="enrollmentViewModel.LTCFACILITY"
                         [LTCFacilityPhone]="enrollmentViewModel.LTCPHONE"
                         [states]="states"
                         [disabled]="disabled"
                         [isExternalAgentEnrl] ="isExternalAgentEnrl"
                         [allowPOBoxes]="!enrollmentViewModel.ISSINGLEGROUP"
                         (onTopAddressChange)="residentialAddressChanged($event)"
                         (onBottomAddressChange)="mailingAddressChanged($event)"
                         (onLTCFacilityNameChange)="enrollmentViewModel.LTCFACILITY=$event"
                         (onLTCFacilltyPhoneChange)="enrollmentViewModel.LTCPHONE=$event">
            </DualAddress>
        </div>
    </div>
    <!--<div class="row" *ngIf="!enrollmentViewModel.ISSINGLEGROUP;else other_content">-->
    <div class="row">
        <div class="col-24">
            <!--<eob (onEobOptionChange)="this.eobOptionChanged($event)"
            [EOBEmaildisabled]="false"
            [eobOption]="enrollmentViewModel.EOB"
            (onEmailChange)="this.emailChanged($event)"
            [email]="enrollmentViewModel.APPEMAIL"
            [PaperlessOption]="PaperlessOption"></eob>-->
            <div *ngIf="PaperlessOption">
                <div class="row">
                    <div class="col-16">
                        <p><strong>Paperless Settings</strong></p>
                    </div>
                    <div class="col-16">
                        <p>
                            Would you like to receive paperless Explanation of Benefit (EOB) statements?
                        </p>
                        <div class="row">
                            <br />
                        </div>
                        <p>
                            We'll send you a monthly email letting you know how to access and view your secure EOB statement. You will need to provide us with your email address.  You can opt out at any time.
                        </p>
                    </div>

                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <!--<p><strong>Do you want paperless documents?</strong></p>-->
                        </div>
                        <div class="bottom-20">
                            <ValidatedCheckbox [id]="'EOBoption'"
                                               [label]="'Yes, I want to receive my EOB statements electronically.'"
                                               [checked]="isEOB"
                                               (onValueChange)="eobCheckOptionChanged($event)">

                            </ValidatedCheckbox>
                        </div>
                    </div>
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                Visit the online preference center at <a class="link" target="_blank" href="https://www.aetnamedicare.com/">aetnamedicare.com</a> once you complete your registration by clicking Login and following the steps for register. See exactly what's available for you to receive digitally and manage your document delivery preferences between digital and mailed. You may go back to paper at any time. Please note that some documents may take up to two months to switch to digital delivery. Thank you for going paperless!
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <label>{{emailLabel}}</label>
                            <ValidatedTextField class="" [maxlength]="40"
                                                [label]=""
                                                id="EmailAddress"
                                                [text]="enrollmentViewModel.APPEMAIL"
                                                (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>

                </div>
                <div class="row" *ngIf="!enrollmentViewModel.ISSINGLEGROUP">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                We will use your email address to keep you up to date on your SilverScript plan.
                                You can opt out any time.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!PaperlessOption && !enrollmentViewModel.ISSINGLEGROUP">

                <div class="row">
                    <div class="col-16">
                        <p><strong>Would you like to receive paperless Explanation of Benefit (EOB) statements?</strong></p>
                        <p>We'll send you a monthly email alert to view your statement. You can print it only if you need to - keep the clutter down and your information secure.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <ValidatedRadioButtonGroup [options]="rdBtnEOB"
                                                       [selectedValue]="enrollmentViewModel.EOB"
                                                       [radioGroupName]="'rdBtnEOB'"
                                                       (onValueChange)="eobOptionChanged($event)">
                            </ValidatedRadioButtonGroup>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <label>{{emailLabel}}</label>
                            <ValidatedTextField class="" [maxlength]="40"
                                                [label]=""
                                                id="EmailAddress"
                                                [text]="enrollmentViewModel.APPEMAIL"
                                                (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                We will use your email address to keep you up to date on your SilverScript plan.
                                You can opt out any time.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                The Explanation of Benefits (EOB) is a record of your prescription claims that have been processed for the month. The EOB statement shows each prescription’s cost,
                                the amount your plan has paid toward its cost, and the amount for which you’re responsible. You can change your preference on caremark.com at any time.
                            </p>
                            <p>
                                If you choose to receive paperless Explanation of Benefit statements, you will need to create an account on Caremark.com.
                                In addition to viewing your EOB statements online, Caremark.com will give you the ability to track your prescription costs and order mail service prescriptions.
                            </p>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <div *ngIf="enrollmentViewModel.ISSINGLEGROUP && !PaperlessOption">
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Email Address (optional)'" [maxlength]="40"
                                        [text]="enrollmentViewModel.APPEMAIL"
                                        (onValueChange)="enrollmentViewModel.APPEMAIL = $event">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!enrollmentViewModel.ISSINGLEGROUP">
        <div class="col-24">
            <payment-method id="payment-method"
                            (onPaymentOptionChange)="this.paymentOptionChanged($event)"
                            (onPaymentAccountChange)="this.paymentAccountChanged($event)"
                            [paymentOption]="this.paymentOption"
                            [paymentAccount]="this.paymentAccount">
            </payment-method>
        </div>
    </div>




    <div *ngIf="showSTCOBFields">
        <stcob-fields [enrollment]="enrollmentViewModel" [isSingleGroup]="enrollmentViewModel.ISSINGLEGROUP"></stcob-fields>
    </div>

    <div class="row" *ngIf="enrollmentViewModel.ISSINGLEGROUP">
        <div class="col-24">
            <fieldset>
                <legend>Client Defined Data</legend>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField class="field field--single"
                                                [label]="'External Member ID'"
                                                [text]="enrollmentViewModel.EXTERNALID"
                                                [disabled]="disabled"
                                                [maxlength]="20"
                                                (onValueChange)="enrollmentViewModel.EXTERNALID=$event"
                                                [validators]="[alphanumericValidator]">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField class="field field--single"
                                                [label]="'Care Facility'"
                                                [text]="enrollmentViewModel.CAREFAC"
                                                [disabled]="disabled"
                                                [maxlength]="6"
                                                (onValueChange)="enrollmentViewModel.CAREFAC=$event"
                                                [validators]="[alphanumericValidator]">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField class="field field--single"
                                                [label]="'Care Qualifier'"
                                                [text]="enrollmentViewModel.CAREQUAL"
                                                [disabled]="disabled"
                                                [maxlength]="10"
                                                (onValueChange)="enrollmentViewModel.CAREQUAL=$event"
                                                [validators]="[alphanumericValidator]">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>

            </fieldset>
        </div>
    </div>

    <div class="row" *ngIf="enrollmentViewModel.ISSINGLEGROUP">
        <div class="col-24">
            <fieldset>
                <legend>Creditable Coverage</legend>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <ValidatedRadioButtonGroup [label]="'Does the Applicant have Creditable Coverage'"
                                                       [options]="creditOptions"
                                                       [disabled]="'false'"
                                                       [radioGroupName]="'creditCoverage'"
                                                       [selectedValue]="enrollmentViewModel.CC"
                                                       (onValueChange)="enrollmentViewModel.CC=$event">
                            </ValidatedRadioButtonGroup>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="input-wrapper bottom-20">
                            <!-- text box -->
                            <ValidatedTextField class="field field--single"
                                                [label]="'Number of months the applicant did not have any creditable prescription drug coverage but was eligible for Medicare Part D. Up to 3 characters - digits only'"
                                                id="credit-month"
                                                [text]="enrollmentViewModel.UNMTHS"
                                                (onValueChange)="enrollmentViewModel.UNMTHS=$event"
                                                [disabled]="'false'">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
    <div class="row" style="clear:left;display:flex;">
        <div class="col-24">
            <prescripitionDrug [enrollment]="enrollmentViewModel" 
                               [isExternalAgentEnrl] ="isExternalAgentEnrl"
                               [showOtherCoverage]="showOtherCoverage"
                               #prescripitionDrug>
            </prescripitionDrug>
        </div>
    </div>
    <div class="row" style="display:flex;">
        <div class="col-24">
            <accessibility [accessibilityValue]="accessibilityValue" [enrollment]="enrollmentViewModel"></accessibility>
            <!--<accessibility #accessibility></accessibility>-->
        </div>
    </div>


    <div class="row">
        <div class="col-24">
            <notes [enrollment]="enrollmentViewModel"></notes>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Continue</button>
            <button class="button cancel" (click)="goBack()">Go Back</button>

        </div>
    </div>
</div>
